{
  "version": 1,
  "asset_id": "8d22e979-a574-4f2a-844e-9dd87f836ed4",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/8d22e979-a574-4f2a-844e-9dd87f836ed4/acreditados-vp-codelco.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/8d22e979-a574-4f2a-844e-9dd87f836ed4/acreditados-vp-codelco.png",
  "original_filename": "acreditados-vp-codelco.png",
  "size": 18245,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:13Z"
}
